var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',{ref:"modal",staticClass:"c-modal l-modal",style:(_vm.positionStyle)},[_c(_vm.modal.component,_vm._b({tag:"component",on:{"close":_vm.hide}},'component',_vm.modal.props,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }